import { Component, EventEmitter, Output } from '@angular/core';
import { InputComponent } from '../@common/input/input.component';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    imports: [InputComponent, FormsModule],
})
export class SearchComponent {
  constructor() {}

  @Output() filter: EventEmitter<string> = new EventEmitter<string>();

  protected search: string;

  protected updateSearch(): void {
    console.log('update');

    this.filter.emit(this.search);
  }
}
